// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopCustomerAccountControllerGetAccountActiveTicketsData } from './EshopCustomerAccountControllerGetAccountActiveTicketsData.gen';
import type { EshopCustomerAccountControllerGetAccountActiveTicketsErrors } from './EshopCustomerAccountControllerGetAccountActiveTicketsErrors.gen';
import type { EshopCustomerAccountControllerGetAccountActiveTicketsResponses } from './EshopCustomerAccountControllerGetAccountActiveTicketsResponses.gen';
import type { EshopCustomerAccountControllerGetAccountRelatedCustomersData } from './EshopCustomerAccountControllerGetAccountRelatedCustomersData.gen';
import type { EshopCustomerAccountControllerGetAccountRelatedCustomersErrors } from './EshopCustomerAccountControllerGetAccountRelatedCustomersErrors.gen';
import type { EshopCustomerAccountControllerGetAccountRelatedCustomersResponses } from './EshopCustomerAccountControllerGetAccountRelatedCustomersResponses.gen';
import type { EshopCustomerAccountControllerGetCustomerCartLifeTimeData } from './EshopCustomerAccountControllerGetCustomerCartLifeTimeData.gen';
import type { EshopCustomerAccountControllerGetCustomerCartLifeTimeErrors } from './EshopCustomerAccountControllerGetCustomerCartLifeTimeErrors.gen';
import type { EshopCustomerAccountControllerGetCustomerCartLifeTimeResponses } from './EshopCustomerAccountControllerGetCustomerCartLifeTimeResponses.gen';
import type { EshopCustomerAccountControllerGetCustomerLastActivePortableCardData } from './EshopCustomerAccountControllerGetCustomerLastActivePortableCardData.gen';
import type { EshopCustomerAccountControllerGetCustomerLastActivePortableCardErrors } from './EshopCustomerAccountControllerGetCustomerLastActivePortableCardErrors.gen';
import type { EshopCustomerAccountControllerGetCustomerLastActivePortableCardResponses } from './EshopCustomerAccountControllerGetCustomerLastActivePortableCardResponses.gen';
import type { EshopCustomerAccountControllerChangeChildAccountToRegularAccountData } from './EshopCustomerAccountControllerChangeChildAccountToRegularAccountData.gen';
import type { EshopCustomerAccountControllerChangeChildAccountToRegularAccountErrors } from './EshopCustomerAccountControllerChangeChildAccountToRegularAccountErrors.gen';
import type { EshopCustomerAccountControllerChangeChildAccountToRegularAccountResponses } from './EshopCustomerAccountControllerChangeChildAccountToRegularAccountResponses.gen';
import type { EshopCustomerAccountControllerNullCustomerCartLifetimeData } from './EshopCustomerAccountControllerNullCustomerCartLifetimeData.gen';
import type { EshopCustomerAccountControllerNullCustomerCartLifetimeErrors } from './EshopCustomerAccountControllerNullCustomerCartLifetimeErrors.gen';
import type { EshopCustomerAccountControllerNullCustomerCartLifetimeResponses } from './EshopCustomerAccountControllerNullCustomerCartLifetimeResponses.gen';
import type { EshopCustomerAccountControllerRemoveCustomerAccountData } from './EshopCustomerAccountControllerRemoveCustomerAccountData.gen';
import type { EshopCustomerAccountControllerRemoveCustomerAccountErrors } from './EshopCustomerAccountControllerRemoveCustomerAccountErrors.gen';
import type { EshopCustomerAccountControllerRemoveCustomerAccountResponses } from './EshopCustomerAccountControllerRemoveCustomerAccountResponses.gen';
import type { EshopCustomerAccountControllerUpdateSettingsData } from './EshopCustomerAccountControllerUpdateSettingsData.gen';
import type { EshopCustomerAccountControllerUpdateSettingsErrors } from './EshopCustomerAccountControllerUpdateSettingsErrors.gen';
import type { EshopCustomerAccountControllerUpdateSettingsResponses } from './EshopCustomerAccountControllerUpdateSettingsResponses.gen';
import type { EshopCustomerAccountControllerVerifyEmailExistsData } from './EshopCustomerAccountControllerVerifyEmailExistsData.gen';
import type { EshopCustomerAccountControllerVerifyEmailExistsErrors } from './EshopCustomerAccountControllerVerifyEmailExistsErrors.gen';
import type { EshopCustomerAccountControllerVerifyEmailExistsResponses } from './EshopCustomerAccountControllerVerifyEmailExistsResponses.gen';
import type { Options } from './Options.gen';

export class EshopCustomerAccountController {
    /**
     * Get card application.
     */
    public static getAccountRelatedCustomers<ThrowOnError extends boolean = false>(options?: Options<EshopCustomerAccountControllerGetAccountRelatedCustomersData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopCustomerAccountControllerGetAccountRelatedCustomersResponses, EshopCustomerAccountControllerGetAccountRelatedCustomersErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-accounts-related-customers',
            ...options
        });
    }
    
    /**
     * Update account setting.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.
     */
    public static updateSettings<ThrowOnError extends boolean = false>(options: Options<EshopCustomerAccountControllerUpdateSettingsData, ThrowOnError>) {
        return (options.client ?? client).put<EshopCustomerAccountControllerUpdateSettingsResponses, EshopCustomerAccountControllerUpdateSettingsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-accounts/settings',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get active tickets from registered or assigned customers for account.
     */
    public static getAccountActiveTickets<ThrowOnError extends boolean = false>(options?: Options<EshopCustomerAccountControllerGetAccountActiveTicketsData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopCustomerAccountControllerGetAccountActiveTicketsResponses, EshopCustomerAccountControllerGetAccountActiveTicketsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-accounts-active-tickets',
            ...options
        });
    }
    
    /**
     * Remove customer eshop account.
     */
    public static removeCustomerAccount<ThrowOnError extends boolean = false>(options: Options<EshopCustomerAccountControllerRemoveCustomerAccountData, ThrowOnError>) {
        return (options.client ?? client).delete<EshopCustomerAccountControllerRemoveCustomerAccountResponses, EshopCustomerAccountControllerRemoveCustomerAccountErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-accounts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get customer cart lifetime.
     */
    public static getCustomerCartLifeTime<ThrowOnError extends boolean = false>(options?: Options<EshopCustomerAccountControllerGetCustomerCartLifeTimeData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopCustomerAccountControllerGetCustomerCartLifeTimeResponses, EshopCustomerAccountControllerGetCustomerCartLifeTimeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-accounts/cart-lifetime',
            ...options
        });
    }
    
    /**
     * Null customer cart lifetime.
     */
    public static nullCustomerCartLifetime<ThrowOnError extends boolean = false>(options?: Options<EshopCustomerAccountControllerNullCustomerCartLifetimeData, ThrowOnError>) {
        return (options?.client ?? client).put<EshopCustomerAccountControllerNullCustomerCartLifetimeResponses, EshopCustomerAccountControllerNullCustomerCartLifetimeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-accounts/cart-lifetime-nullify',
            ...options
        });
    }
    
    /**
     * Change child account to regular account.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **CANNOT_CHANGE_CHILD_ACCOUNT_TO_REGULAR_ACCOUNT** - Only a child account, for which a legal representative is no longer required based on the date of birth, can be converted to a regular account.
     */
    public static changeChildAccountToRegularAccount<ThrowOnError extends boolean = false>(options?: Options<EshopCustomerAccountControllerChangeChildAccountToRegularAccountData, ThrowOnError>) {
        return (options?.client ?? client).post<EshopCustomerAccountControllerChangeChildAccountToRegularAccountResponses, EshopCustomerAccountControllerChangeChildAccountToRegularAccountErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-accounts/child-to-regular-account',
            ...options
        });
    }
    
    /**
     * Verify if email exists in the database.
     */
    public static verifyEmailExists<ThrowOnError extends boolean = false>(options: Options<EshopCustomerAccountControllerVerifyEmailExistsData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCustomerAccountControllerVerifyEmailExistsResponses, EshopCustomerAccountControllerVerifyEmailExistsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-accounts/email/{email}/exists',
            ...options
        });
    }
    
    /**
     * Get last portable card for the given customer account.
     *
     * If customer has no last portable card matching, `NOT FOUND` response is returned.
     */
    public static getCustomerLastActivePortableCard<ThrowOnError extends boolean = false>(options?: Options<EshopCustomerAccountControllerGetCustomerLastActivePortableCardData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopCustomerAccountControllerGetCustomerLastActivePortableCardResponses, EshopCustomerAccountControllerGetCustomerLastActivePortableCardErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customer-accounts/last-active-portable-card',
            ...options
        });
    }
}
